import * as types from '../actions/action-types';
import bigQueryMetricRecorder from '../tracking/bigQueryMetricRecorder';
import Track from '../utils/tracking';

const initialState = {
  selectedOverlay: null,
  overlayData: null,
};

const overlayReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.SET_OVERLAY:
      try {
        if (action.overlayID && state.selectedOverlay !== action.overlayID) {
          bigQueryMetricRecorder('CheckoutOverlay', [{
            name: 'action',
            value: action.overlayID,
          }, {
            name: 'type',
            value: 'show',
          }], [], 'impression');
        }
      } catch (error) {
        Track.track(error);
      }
  
      return {
        selectedOverlay: action.overlayID,
        overlayData: action.overlayData,
      };
  
    case types.CLEAR_OVERLAY:
      try {
        if (state.selectedOverlay) {
          bigQueryMetricRecorder('CheckoutOverlay', [{
            name: 'action',
            value: state.selectedOverlay,
          }, {
            name: 'type',
            value: 'hide',
          }], [], 'impression');
        }
      } catch (error) {
        Track.track(error);
      }
      return {
        selectedOverlay: null,
        overlayData: null,
      };
  
    case types.SET_SHOULD_PAUSE_FOCUS_TRAP:
      return {
        ...state,
        shouldPauseFocusTrap: action.shouldPauseFocusTrap,
      };
  
    default:
      return state;
  }
};

export default overlayReducer;
